<div id="natural-stone-finalize-preorder" class="p-4 h-[calc(100vh-81px)] bg-white flex flex-col overflow-y-auto gap-8">
    <div class="w-full flex justify-center p-4">
        <div class="flex-1 max-w-[440px]">
            <app-progress-bar
                [steps]="progressSteps"
                [currentStep]="step"
                orientation="horizontal"
                [showDescription]="true">
            </app-progress-bar>
        </div>
    </div>
    <div class="px-[120px] flex-1 overflow-y-auto">
        <app-natural-stone-finalize-preorder-cart *ngIf="step === 1 && !isFinalStep()" />
        <app-natural-stone-finalize-preorder-info *ngIf="step === 2 && !isFinalStep()" />
        <div *ngIf="isFinalStep()" class="flex flex-col gap-6 md:gap-8">
            <div class="flex flex-col gap-4 md:gap-6">
                <div class="flex justify-center items-center">
                    <img src="assets/icons/check_circle_green.svg" alt="Ok" />
                </div>
                <span class="typography-title-l text-center mb-4 md:mb-6">
                    {{'natural_stone.we_have_informed_your_business_manager' | translate}}
                </span>
            </div>
            <span class="typography-body-l-regular text-center mb-4 md:mb-6">
                {{'natural_stone.we_have_sent_them_the_natural_stone_slabs_you_selected_to_help_you_with_the_process' | translate}}
            </span>
            <div class="flex justify-center items-center">
                <app-button
                    [primary]="true"
                    [size]="'large'"
                    (onClick)="goBackToSelection()"
                >{{'natural_stone.select_more_natural_stone' | translate}}
                </app-button>
            </div>
        </div>
    </div>
    <div *ngIf="!isFinalStep()" class="px-[120px] flex justify-between">
        <div
            (click)="goBack()"
            class="flex items-center text-primary-default cursor-pointer"
            [attr.gtm-label]="'natural-stone-funnel_link_back-to--natural-stone-catalog'"
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path class="primaryDefault"
                      d="M14.0002 17.3L8.7002 12L14.0002 6.69995L14.7002 7.39995L10.1002 12L14.7002 16.6L14.0002 17.3Z"
                      fill="#232323"></path>
            </svg>
            <div>{{ 'natural_stone.go_back_to_the_catalog' | translate }}</div>
        </div>

        <div class="md:min-w-[184px]">
            <app-button
                [primary]="true"
                [size]="'large'"
                [isFullWidth]="true"
                [disabled]="cart().length === 0"
                (onClick)="nextStep(step === progressSteps.length - 1)"
            >
                {{ (step !== progressSteps.length - 1 ? 'global.continue' : 'common.buttons.confirm') | translate}}
            </app-button>
        </div>
    </div>
</div>